"use client";

import { useState, useEffect } from "react";
import CaonaboAlertBell from "./CaonaboAlertBell";

/**
 * Wrapper que monta la bell solo si proactive_alerts está habilitada.
 */
export default function CaonaboAlertBellMaybe() {
  const [enabled, setEnabled] = useState<boolean | null>(null);

  useEffect(() => {
    let cancel = false;
    fetch("/api/caonabo/status", { cache: "no-store" })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (cancel) return;
        setEnabled(Boolean(data?.capas?.proactive_alerts));
      })
      .catch(() => {
        if (!cancel) setEnabled(false);
      });
    return () => {
      cancel = true;
    };
  }, []);

  if (!enabled) return null;
  return <CaonaboAlertBell />;
}
